var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.36,
    height: 13.352,
    viewBox: "0 0 18.36 13.352",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-delete",
    "data-name": "Icon feather-delete",
    transform: "translate(-1.5 -6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_268",
    "data-name": "Path 268",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.191,6H7.342L1.5,12.676l5.842,6.676H18.191a1.669,1.669,0,0,0,1.669-1.669V7.669A1.669,1.669,0,0,0,18.191,6Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8.249241828918457 7.999998092651367 L 4.15753173828125 12.67623901367188 L 8.249241828918457 17.35247802734375 L 17.85965728759766 17.35247802734375 L 17.85965728759766 7.999998092651367 L 8.249241828918457 7.999998092651367 M 7.341707229614258 5.999998092651367 L 18.19059753417969 5.999998092651367 C 19.11238861083984 5.999998092651367 19.85965728759766 6.747259140014648 19.85965728759766 7.669059753417969 L 19.85965728759766 17.68341827392578 C 19.85965728759766 18.60520935058594 19.11238861083984 19.35247802734375 18.19059753417969 19.35247802734375 L 7.341707229614258 19.35247802734375 L 1.499998092651367 12.67623901367188 L 7.341707229614258 5.999998092651367 Z",
    stroke: "none",
    fill: "#455857"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M23.007,13.5,18,18.507",
    transform: "translate(-7.32 -3.327)",
    fill: "none",
    stroke: "#455857",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M18,13.5l5.007,5.007",
    transform: "translate(-7.32 -3.327)",
    fill: "none",
    stroke: "#455857",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/remove_icon.0b009c135619d84650e5a2836fc33121.svg";
export { ForwardRef as ReactComponent };